import React from 'react'
import DataTableItem from './DataTableItem';

import { connect } from 'react-redux'
import database from '../config'

class DataTable extends React.Component {
  state = {
    data: []
  }
  
  componentDidMount() {
    this.props.fetchData(this.props, this)
  }

  search = e => {
    let query = e.target.value.toLowerCase()
  
    let filteredData = this.props.data.reverse().filter(datum => {
      let searchData = datum.url.toLowerCase()
  
      return searchData.indexOf(query) !== -1
    })
  
    this.setState({
      data: filteredData
    })
  }

  render() {
    let item = this.state.data.map((datum, index) => {
      return(
        <DataTableItem item={ datum } key={ index } {...this.props}/>
      )
    })

    let table = () => { return (
      <section className="bg-white content-section">
        <div className="container">
          <div className="row mt-5 pt-3">
            <div className="col-lg-12 text-center">
              <input type="text" className="form-control my-5 col-lg-5" placeholder="Search...." onChange={this.search}/>
              <table className="table table-hover">
                
                <thead>
                  <tr>
                    <th>Website</th>
                    <th>Email</th>
                    <th>Password</th>
                    <th>Created</th>
                    <th>Updated</th>
                    <th>Action</th>
                  </tr>
                </thead>
                
                <tbody>
                  { item }
                </tbody>
                
              </table>
            </div>
          </div>
        </div>
      </section>
    )}

    return (
      <React.Fragment>
        { this.props.isLoaded ? table() : <div className="pt-5"> <div className="loader"></div> </div> }
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return({
    data: state.fetchDatabase.data,
    isLoaded: state.fetchDatabase.isLoaded
  })
}

const mapDispatchToProps = (dispatch) => {
  return({
    fetchData: (props, self) => {
      dispatch(getData(props, self))
    }
  })
}

const getData = (props, self) => dispatch => {
  database.ref('/').on('value', (snapshot) => {
    let data = []

    snapshot.forEach(datum => {
      if (props.user === datum.val().user) {
        let obj = {
          id: datum.key,
          url: datum.val().url,
          email: datum.val().email,
          password: datum.val().password,
          createdAt: datum.val().createdAt,
          updatedAt: datum.val().updatedAt
        }
  
        data.push(obj)
      }
    })

    self.setState({
      data: data.reverse()
    })

    dispatch({ type: 'FETCH_DATABASE_SUCCESS', payload: data })
  })
}

export default connect(mapStateToProps, mapDispatchToProps)(DataTable)
